import { call, put, select, take, takeEvery } from 'redux-saga/effects'
import { selectProvince, selectScenario, selectScenarioAdditionalInformation } from '../selectors'
import { requestPhones, setPhones } from '../phones-slice'
import { getPhoneList, getPhoneListCondensed } from '../../connectivity/api'
import { finishScenario } from '../scenario-slice'
import { addAnswer } from '../answers-slice'
import { Scenario, ScenarioType, Steps } from '../interfaces'
import * as Sentry from '@sentry/react'
import { nextStep } from '../step-slice'
import { requestPhonesCondensed, setPhonesCondensed } from '../phones-slice-condensed'

export function* mobileSaga() {
  yield takeEvery(requestPhones.type, fetchPhones)
  yield takeEvery(requestPhonesCondensed.type, fetchPhonesCondensed)
  yield takeEvery(addAnswer.type, answerAdded)
  yield takeEvery(nextStep.type, nextStepAdded)
}

export function* answerAdded(action: ReturnType<typeof addAnswer>) {
  if (action.payload.stepId === Steps.PHONE_MODEL_ID) {
    const scenario: Scenario = yield select(selectScenario)

    if (
      (scenario.type === ScenarioType.MOBILE || scenario.type === ScenarioType.QUICK_SEARCH_MOBILE) &&
      scenario.id !== 'mobile-d'
    ) {
      yield put(finishScenario({ [action.payload.stepId]: action.payload.answerIds }))
    }

    if (scenario.type === ScenarioType.PHONE_SEARCH) {
      yield put(finishScenario({ [action.payload.stepId]: action.payload.answerIds }))
    }
  }

  if (action.payload.stepId === Steps.PHONE_ID) {
    const scenario: Scenario = yield select(selectScenario)

    if (scenario.type === ScenarioType.PHONE_SEARCH) {
      yield put(finishScenario({ [action.payload.stepId]: action.payload.answerIds }))
    }
  }

  if (action.payload.stepId === Steps.BUY_OR_BRING_PHONE_QUICK_SEARCH) {
    const scenario: Scenario = yield select(selectScenario)
    const scenarioAdditionalInformation: Record<string, unknown> = yield select(selectScenarioAdditionalInformation)

    if (scenario.type === ScenarioType.QUICK_SEARCH_MOBILE && scenarioAdditionalInformation?.variant === 'byod') {
      yield put(finishScenario())
    }
  }
}

export function* nextStepAdded({ payload }: ReturnType<typeof nextStep>) {
  const scenario: Scenario = yield select(selectScenario)
  const scenarioAdditionalInformation: Record<string, unknown> = yield select(selectScenarioAdditionalInformation)

  if (scenario?.type === ScenarioType.QUICK_SEARCH_MOBILE && scenarioAdditionalInformation?.variant === 'byod') {
    if (payload?.id === Steps.HOW_MUCH_DATA) {
      yield put(
        addAnswer({
          stepId: Steps.BUY_OR_BRING_PHONE_QUICK_SEARCH,
          answerIds: ['byod', 'finishScenario'] as string[],
          hidden: false,
        }),
      )
    }
  }

  if (scenario?.type === ScenarioType.QUICK_SEARCH_MOBILE && scenarioAdditionalInformation?.variant === 'phone') {
    if (payload?.id === Steps.HOW_MUCH_DATA) {
      yield put(
        addAnswer({
          stepId: Steps.BUY_OR_BRING_PHONE_QUICK_SEARCH,
          answerIds: ['purchase-phone'] as string[],
          hidden: false,
        }),
      )
    }
  }
}

export function* refreshPhonesSync() {
  yield put(requestPhones())
  yield take(setPhones.type)
}

export function* refreshPhonesCondensedSync() {
  yield put(requestPhonesCondensed())
  yield take(setPhonesCondensed.type)
}

export function* fetchPhones() {
  const province: string = yield select(selectProvince)

  try {
    yield put(setPhones(yield call(getPhoneList, province)))
  } catch (error: any) {
    Sentry.captureMessage(error)
  }
}

export function* fetchPhonesCondensed() {
  try {
    yield put(setPhonesCondensed(yield call(getPhoneListCondensed)))
  } catch (error: any) {
    Sentry.captureMessage(error)
  }
}
